import type { AccountSelectorInfo, SubAdjustmentRow } from './types'

export const baseColumns = 7
export const emptyColumnControlRowSpan = 3

export const emptyAccountSelectorInfo: AccountSelectorInfo = {
  accounts: [],
  accountsText: '',
  newAccounts: [],
  newAccountsText: '',
}

export const emptySubAdjustment: SubAdjustmentRow = {
  account: {
    id: null,
    actualValue: 0,
    name: '',
    number: '',
    originalName: '',
    originalNumber: '',
  },
  id: '',
  actions: null,
  description: '',
  valueDebit: null,
  valueCredit: null,
  analyticalDimension0Id: null,
  analyticalDimension1Id: null,
  analyticalDimension2Id: null,
  analyticalDimension3Id: null,
}

export const abortAutocompleteReason =
  'Adjustments::AccountSelect::StaleRequest'
